import { PostDamagedVehicleCorrectiveImagesType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postDamagedVehicleCorrectiveImages/postDamagedVehicleCorrectiveImages.type';
import { postDamagedVehicleCorrectiveImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postDamagedVehicleCorrectiveImages/postDamagedVehicleCorrectiveImagesFunction';
import { postInitialVisitCorrectiveImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postDamagedVehicleCorrectiveImages/postinitialVisitCorrectiveImagesFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const postDamagedVehicleCorrectiveImagesOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PostDamagedVehicleCorrectiveImagesType
> => ({
  mutationKey: ['postDamagedVehicleCorrectiveImagesOptions'],
  mutationFn: (params: PostDamagedVehicleCorrectiveImagesType) => {
    if (params.type === 'initial') {
      return postInitialVisitCorrectiveImagesFunction(params);
    }
    return postDamagedVehicleCorrectiveImagesFunction(params);
  },
});
